var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_8893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80852 25.3758C19.372 25.3758 25.1513 16.622 25.1513 9.03303C25.1513 8.78693 25.1459 8.53537 25.1349 8.28928C26.2592 7.47623 27.2294 6.46915 28 5.31537C26.9529 5.78122 25.8412 6.08547 24.7029 6.21771C25.9015 5.49925 26.799 4.37057 27.2289 3.04092C26.1013 3.70917 24.8682 4.18057 23.5823 4.4349C22.716 3.51434 21.5705 2.90482 20.323 2.70058C19.0754 2.49634 17.7954 2.70875 16.6807 3.30497C15.566 3.90119 14.6788 4.84801 14.1562 5.99905C13.6335 7.15009 13.5047 8.44124 13.7895 9.67287C11.5062 9.55829 9.27259 8.96518 7.23331 7.93197C5.19403 6.89876 3.39464 5.44853 1.9518 3.67529C1.21847 4.93964 0.994066 6.43577 1.3242 7.85963C1.65434 9.28348 2.51424 10.5282 3.72914 11.3408C2.81707 11.3119 1.92497 11.0663 1.12656 10.6244V10.6955C1.12575 12.0224 1.58445 13.3085 2.42469 14.3354C3.26494 15.3623 4.43488 16.0665 5.73562 16.3283C4.89073 16.5595 4.00398 16.5932 3.14398 16.4268C3.51103 17.5679 4.22517 18.5659 5.18673 19.2816C6.1483 19.9973 7.30931 20.3949 8.50773 20.419C6.47316 22.0171 3.95987 22.884 1.37266 22.8799C0.913835 22.8792 0.455466 22.8511 0 22.7957C2.62833 24.4819 5.68579 25.3775 8.80852 25.3758Z",
    fill: "#FAFBFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_8893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitterWhite.5761fa60350678766a4c9d523080fe50.svg";
export { ForwardRef as ReactComponent };